<template>
  <div>
    <div class="viewInstitute">
      <div class="edit p-2 d-flex justify-content-end">
        <b-button size="sm" variant="info" @click="$emit('editInstitute')">Edit</b-button>
      </div>
      <div class="text-center mb-2" v-if="selectedInstitute.logo">
        <img :src="cloudStorageRoot + selectedInstitute.logo.file_path + selectedInstitute.logo.file_name"
          alt="Institution Logo" class="institution-logo" />
      </div>
      <div class="name text-center">
        <p class="p-0 m-0">{{ selectedInstitute.name }}</p>
        <p class="p-0 m-0 text-info">Institute Code: {{ selectedInstitute.code }}</p>
      </div>
      <p class="text-center p-0 m-0">{{ selectedInstitute.name_2 }}</p>
      <p class="text-center p-0 m-0">
        {{ selectedInstitute.name_3 }}
      </p>
      <p class="text-center p-0 m-0">
        {{ selectedInstitute.university }}
      </p>
      <p class="text-center p-0 m-0">
        {{ selectedInstitute.line_3 }}
      </p>
      <br />
      <div class="address">
        <span class="font-weight-bolder">Address: </span> <br />
        <span>{{ selectedInstitute.address }}</span> <br />
        <span v-if="selectedInstitute.address2 != null">{{
        selectedInstitute.address2
        }}</span>
        <br />
        <span>{{ selectedInstitute.state }}</span> <br />
        <span>{{ selectedInstitute.country }}</span> <br />
        <span>{{ selectedInstitute.pincode }}</span> <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["selectedInstitute"],
  computed: {
    cloudStorageRoot() {
      return this.$store.getters.getAPIKey.userAttachments;
    },
  },
};
</script>

<style >
.viewInstitute {
  border: 2px solid #17a2b8;
  padding: 20px;
  border-radius: 5px;
  font-weight: 600;
}

.viewInstitute .name p {
  font-size: 16px !important;
}

.viewInstitute .name p:nth-child(2) {
  font-size: 12px !important;
}

.viewInstitute .institution-logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  background: #fff;
}
</style>
